import { useState } from 'react';
import InputField from '../../../../../components/molecules/InputField';

const NodeUpdates = ({ config }) => {
    const [selectedForm, setSelectedForm] = useState(0);
    return (
        <div className='border rounded'>
            {config &&
                config.map((row, index) => {
                    return (
                        <div className='panel__section p-2'>
                            <div className='d-flex align-items-center justify-content-between'>
                                <div className='d-flex align-items-center'>
                                    <i
                                        className={`bi database-fill-check me-1 ${
                                            selectedForm === index ? 'text-info' : ''
                                        }`}></i>
                                    <h5
                                        onClick={() =>
                                            setSelectedForm(selectedForm === index ? -1 : index)
                                        }
                                        className='fs-8 p-0 m-0 cursor-pointer'>
                                        {row?.template?.path}
                                    </h5>
                                </div>
                                <div>
                                    <span className='cursor-pointer ms-1'>
                                        <i className='bi bi-dash-circle-fill'></i>
                                    </span>
                                    <span
                                        className='cursor-pointer ms-2'
                                        onClick={() =>
                                            setSelectedForm(selectedForm === index ? -1 : index)
                                        }>
                                        <i
                                            className={`bi bi-chevron-${
                                                selectedForm === index ? 'up' : 'down'
                                            }`}></i>
                                    </span>
                                </div>
                            </div>
                            {selectedForm === index && (
                                <div className='mt-2'>
                                    <div className='d-flex align-items-center mb-2'>
                                        <label className='fs-8 w-50px'>Key</label>
                                        <InputField
                                            defaultValue={row?.template?.path}
                                            config={{
                                                name: 'key',
                                                placeholder: 'Key',
                                                className: 'form-control-xs',
                                            }}
                                        />
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <label className='fs-8 w-50px'>Value</label>
                                        <InputField
                                            defaultValue={row?.template.value}
                                            config={{
                                                name: 'value',
                                                placeholder: 'Value',
                                                className: 'form-control-xs',
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            <div className='d-flex justify-content-center py-2'>
                <i className='bi bi-plus-lg'></i>
            </div>
        </div>
    );
};
export default NodeUpdates;
